import { Component, inject, input } from '@angular/core';
import { filter, Observable, tap } from 'rxjs';
import { AdsTypeService } from '~app/app/~shared/services/ads-type.service';
import { DialogService } from '~app/app/~shared/services/dialog.service';
import { ResourceFacade } from '~app/app/~store/facades/resource.facade';
import { AdsType } from '~core/models/ads-type.models';
import { AdsTypeCreationDialogComponent } from '../../modals/ads-type-creation-dialog/ads-type-creation-dialog.component';
import { DeleteConfirmComponent } from '~app/app/~shared/components/modals/delete-confirm/delete-confirm.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BaseComponent } from '~app/app/~shared/abstract-components/base.component';

@Component({
  selector: 'ads-type-list-datatable',
  templateUrl: './ads-type-list-datatable.component.html',
  styleUrl: './ads-type-list-datatable.component.scss'
})
export class AdsTypeListDatatableComponent extends BaseComponent {
  private _dialogService = inject(DialogService);
  private _adsTypeService = inject(AdsTypeService);
  private _resourceFacade = inject(ResourceFacade);

  adsTypes = input<AdsType[]>([]);

  displayedColumns: string[] = ['name', 'mediaType', 'actions'];

  openEditDialog(type: AdsType): Observable<unknown> {
    const dialogRef = this._dialogService.open({
      component: AdsTypeCreationDialogComponent,
      fullscreen: true
    });

    dialogRef.componentRef?.setInput('adsType', type);

    return dialogRef.afterClosed();
  }

  openDeleteDialog(type: AdsType): void {
    const delete$ = this._adsTypeService.remove(type.id);

    const dialogRef = this._dialogService.open({
      component: DeleteConfirmComponent,
      config: {
        panelClass: ['mat-dialog-custom'],
        disableClose: true
      }
    });

    dialogRef.componentInstance.removeObservable$ = delete$;
    dialogRef.componentRef?.setInput(
      'title',
      `Voulez-vous supprimer le type "${type.name}" ?`
    );

    dialogRef
      .afterClosed()
      .pipe(
        filter(Boolean),
        takeUntilDestroyed(this._destroyRef),
        tap({
          next: () => {
            this._resourceFacade.getData({ refresh: true });
            this._snackbarService.open({
              text: 'Type de publicité supprimé avec succès',
              type: 'success'
            });
          }
        })
      )
      .subscribe();
  }
}
